import { SubscriptionType } from 'features/user/ts';
import { ReactComponent as Checked } from 'assets/icons/check.svg';
import CancelIcon from '@material-ui/icons/Cancel';
import React from 'react';
import { GetTranslationFunction } from 'ts/translation';

export const getAvailableActionsWithSubscriptionPlan = (
  subscription: SubscriptionType | undefined,
  t: GetTranslationFunction
) => {
  let actions = [
    {
      title: t('availableActions.viewOnly'),
      icon: <Checked />,
      available: true,
    },
    {
      title: t('availableActions.sendEngagingRewards'),
      icon: <CancelIcon />,
      available: false,
    },
    {
      title: t('availableActions.topUpYourAccount'),
      icon: <CancelIcon />,
      available: false,
    },
    {
      title: t('availableActions.inviteTeamMembers'),
      icon: <CancelIcon />,
      available: false,
    },
  ];
  if (subscription) {
    actions = actions.map((el, index) => {
      switch (index) {
        case 0: {
          switch (subscription.subscription_plan) {
            case 'BASIC': {
              el.title = t('availableActions.oneUser');
              break;
            }
            case 'PREMIUM': {
              el.title = t('availableActions.upToTenUsers');
              break;
            }
            case 'ENTERPRISE': {
              el.title = t('availableActions.unlimitedUsers');
              break;
            }
          }
          break;
        }
        case 1:
          {
            switch (subscription.subscription_plan) {
              case 'ENTERPRISE': {
                el.title = t('cards.unlimitedReward');
                break;
              }
              default: {
                el.title = t('availableActions.3ProcessingFeeOnTopUp');
              }
            }
          }
          break;
        case 2:
          {
            switch (subscription.subscription_plan) {
              case 'ENTERPRISE': {
                el.title = t('cards.automaticReCrediting');
                break;
              }
              default: {
                el.title = t('availableActions.noSetupFee');
              }
            }
          }
          break;
        case 3:
          {
            switch (subscription.subscription_plan) {
              case 'ENTERPRISE': {
                el.title = t('availableActions.noSetupFee');
                break;
              }
              default: {
                el.title = t('availableActions.freeBankTransfer');
              }
            }
          }
          break;
      }

      return { ...el, icon: <Checked />, available: true };
    });
  }

  return actions;
};

export const getCardAvailableActions = (t: GetTranslationFunction) => {
  return [
    {
      title: t('cards.3ProcessingFee'),
    },
    {
      title: t('availableActions.noSetupFee'),
    },
    {
      title: t('cards.automaticReCrediting'),
    },
    {
      title: t('cards.arabicAndEnglish'),
    },
    {
      title: t('cards.unlimitedReward'),
    },
  ];
};
